import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

function Privacy() {
  return (
    <main
      id="MainContent"
      className="content-for-layout focus-none"
      role="main"
      tabIndex={-1}
    >
      <div className="policy__container">
        <div className="policy__title">
          <h1>Privacy policy</h1>
        </div>
        <div className="policy__body">
          <div className="rte">
            <p>DILVERBLOOM PRIVACY NOTICE</p>
            <p>Last updated: September 8, 2026</p>

            <p>1. INFORMATION WE COLLECT</p>
            <p>
              When you place an order or contact us, we may collect information
              you provide, including your name, email address, telephone number,
              billing and shipping address, order details, and message content.
              Our service providers may also process device, browser, IP address,
              and transaction information needed to operate and secure the site.
            </p>

            <p>2. HOW WE USE INFORMATION</p>
            <p>
              We use information to process and deliver orders, provide customer
              support, communicate about purchases, prevent fraud, maintain site
              security, meet legal obligations, and improve our services. We send
              marketing messages only where permitted and you can opt out using
              the instructions in those messages or by contacting us.
            </p>

            <p>3. PAYMENT INFORMATION</p>
            <p>
              Payment details are handled by the payment service used at checkout.
              Dilverbloom does not use browser cart storage to retain full payment
              card numbers or security codes. The payment provider&apos;s own privacy
              notice applies to information it processes.
            </p>

            <p>4. WHEN WE SHARE INFORMATION</p>
            <p>
              We may share information with providers that help us host the site,
              process payments, fulfill and deliver orders, communicate with
              customers, or protect the business. We may also disclose information
              when required by law, to protect rights and safety, or in connection
              with a business transfer. We do not sell personal information for
              money.
            </p>

            <p>5. COOKIES AND LOCAL STORAGE</p>
            <p>
              The site uses browser local storage to remember items in your cart.
              Other essential technologies may be used by service providers when
              their features are loaded. You can manage these technologies through
              your browser. For details, read our <Link to="/cookies">Cookie Policy</Link>.
            </p>

            <p>6. DATA RETENTION</p>
            <p>
              We keep personal information only for as long as reasonably needed
              for the purposes described here, including order administration,
              recordkeeping, dispute resolution, security, and legal compliance.
              Retention periods vary by the type of information and applicable law.
            </p>

            <p>7. YOUR CHOICES AND PRIVACY RIGHTS</p>
            <p>
              Depending on where you live, you may have rights to request access,
              correction, deletion, or a copy of personal information, or to object
              to or restrict certain uses. To make a request, email us using the
              contact information below. We may need to verify your identity before
              completing a request.
            </p>

            <p>8. SECURITY</p>
            <p>
              We use reasonable administrative and technical measures designed to
              protect personal information. No method of transmission or storage is
              completely secure, so we cannot guarantee absolute security.
            </p>

            <p>9. CHILDREN</p>
            <p>
              This site is intended for a general audience and is not directed to
              children under 13. We do not knowingly collect personal information
              from children under 13.
            </p>

            <p>10. THIRD-PARTY LINKS</p>
            <p>
              Links to other websites or services are governed by those third
              parties&apos; own terms and privacy notices. Dilverbloom is not responsible
              for their privacy practices.
            </p>

            <p>11. CHANGES TO THIS POLICY</p>
            <p>
              We may update this policy as our practices or legal obligations
              change. The latest revision date will appear at the top of this page.
            </p>

            <p>QUESTIONS AND CONTACT INFORMATION</p>
            <p>
              To ask a privacy question or submit a request, contact our Privacy
              Compliance Officer at build@dilverbloom.online or by mail at:
              <br />
              Dilverbloom
              <br />
              [Re: Privacy Compliance Officer]
              <br />
              1401 S. BOYLE AVE ST. LOUIS Missouri US 63110
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default Privacy;
